<template>
  <path
    d="M15 21.0002H17V19.0002H15V21.0002ZM19 21.0002H21V19.0002H19V21.0002ZM7 21.0002H9V19.0002H7V21.0002ZM11 21.0002H13V19.0002H11V21.0002ZM19 17.0002H21V15.0002H19V17.0002ZM19 13.0002H21V11.0002H19V13.0002ZM3 5.00024V20.0002C3 20.5502 3.45 21.0002 4 21.0002C4.55 21.0002 5 20.5502 5 20.0002V6.00024C5 5.45024 5.45 5.00024 6 5.00024H20C20.55 5.00024 21 4.55024 21 4.00024C21 3.45024 20.55 3.00024 20 3.00024H5C3.9 3.00024 3 3.90024 3 5.00024ZM19 9.00024H21V7.00024H19V9.00024Z"
  />
</template>
